export var VariableDataType;
(function (VariableDataType) {
    VariableDataType[VariableDataType["Bit"] = 0] = "Bit";
    VariableDataType[VariableDataType["UInt16"] = 1] = "UInt16";
    VariableDataType[VariableDataType["Int16"] = 2] = "Int16";
    VariableDataType[VariableDataType["Bcd16"] = 3] = "Bcd16";
    VariableDataType[VariableDataType["Hex16"] = 4] = "Hex16";
    VariableDataType[VariableDataType["Binary16"] = 5] = "Binary16";
    VariableDataType[VariableDataType["UInt32"] = 11] = "UInt32";
    VariableDataType[VariableDataType["Int32"] = 12] = "Int32";
    VariableDataType[VariableDataType["Bcd32"] = 13] = "Bcd32";
    VariableDataType[VariableDataType["Hex32"] = 14] = "Hex32";
    VariableDataType[VariableDataType["Binary32"] = 15] = "Binary32";
    VariableDataType[VariableDataType["Single"] = 16] = "Single";
    VariableDataType[VariableDataType["UInt64"] = 21] = "UInt64";
    VariableDataType[VariableDataType["Int64"] = 22] = "Int64";
    VariableDataType[VariableDataType["Bcd64"] = 23] = "Bcd64";
    VariableDataType[VariableDataType["Hex64"] = 24] = "Hex64";
    VariableDataType[VariableDataType["Binary64"] = 25] = "Binary64";
    VariableDataType[VariableDataType["Double"] = 26] = "Double";
    VariableDataType[VariableDataType["String"] = 30] = "String";
})(VariableDataType || (VariableDataType = {}));
